import React from "react";
import "./about.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import logokbp from "../../Media/Greenwood/Logo Greenwood (2).png";

const aboutkbp = () => {
  const aboutwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285338197085&text=Halo%20Tia,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Kota%20Baru%20Parahyangan%20https://gcb-greenwoodscountrybogor.id//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="aboutkbp">
      <div id="about" className="container-aboutkbp">
        <div className="heading-aboutkbp">
          <div className="logokbp">
            <img className="gambarkbp" src={logokbp} alt="logo-kbp" />
          </div>
          <div className="judulkbp">Elegant Living with Lakefront Views</div>
          <div className="desk">
            Greenwoods Country Bogor adalah kawasan hunian hijau eksklusif di
            Bogor yang menggabungkan konsep sustainable living dan resort living
            dalam satu lingkungan. Berlokasi di area strategis seluas 9,3 hektar
            dengan potensi pengembangan hingga 20 hektar, perumahan ini
            menghadirkan hunian modern yang menyatu dengan alam. Dikelilingi
            oleh danau alami, taman asri, area olahraga, dan fasilitas outdoor
            lainnya, Greenwoods Country Bogor menawarkan gaya hidup sehat dan
            nyaman bagi keluarga. Lebih dari sekadar perumahan di Bogor, ini
            adalah pilihan ideal bagi Anda yang mencari keseimbangan antara
            kenyamanan, kualitas hidup tinggi, dan keindahan lingkungan hijau.
          </div>
          <div className="button">
            <button className="wa" onClick={aboutwa}>
              <FontAwesomeIcon icon={faWhatsapp} />
              &nbsp; More Info
            </button>
          </div>
        </div>
        <div className="gambaraboutkbp"></div>
      </div>
    </div>
  );
};

export default aboutkbp;
